import { INTELLIGENT_PHOTO_CAPTURE_ON_VIEW_CHANGE, INTELLIGENT_PHOTO_CAPTURE_SAVE_CAPTURED_PHOTO, INTELLIGENT_PHOTO_CAPTURE_CLICK_NEXT_QUESTION, INTELLIGENT_PHOTO_CAPTURE_CAMERA_MODEL_SUCCESS, INTELLIGENT_PHOTO_CAPTURE_RESET_CAPTURED_PHOTO, INTELLIGENT_PHOTO_CAPTURE_PHOTO_UPLOAD_SUCCESS, INTELLIGENT_PHOTO_CAPTURE_PHOTO_UPLOAD_FAILURE, INTELLIGENT_PHOTO_CAPTURE_PROGRESSIVE_IMAGE_MISC_ACTION } from '../actions';
import { IntelligentPhotoCaptureViewType } from '../enums';
export const photoCaptureIntelligentViewChangeReducer = (state, action) => {
    var _a, _b;
    switch (action.type) {
        case INTELLIGENT_PHOTO_CAPTURE_ON_VIEW_CHANGE: {
            return Object.assign(Object.assign({}, state), { lastRenderedView: !(state.view === IntelligentPhotoCaptureViewType.IMAGE_IQA ||
                    state.view === IntelligentPhotoCaptureViewType.RETAKE_PAGE)
                    ? state.view
                    : IntelligentPhotoCaptureViewType.PREVIEW, view: action.payload.view, sequenceScreenName: action.payload.sequenceScreenName, estimatorSelectedTileId: (_a = action.payload.selectedTileId) !== null && _a !== void 0 ? _a : state.estimatorSelectedTileId, shouldNewImageUploaded: action.payload.view === IntelligentPhotoCaptureViewType.CAMERA
                    ? true
                    : action.payload.view === IntelligentPhotoCaptureViewType.NONE
                        ? false
                        : state.shouldNewImageUploaded, contentType: (_b = action.payload.contentType) !== null && _b !== void 0 ? _b : state.contentType });
        }
        case INTELLIGENT_PHOTO_CAPTURE_SAVE_CAPTURED_PHOTO: {
            return Object.assign(Object.assign({}, state), { capturedPhoto: action.payload.file });
        }
        case INTELLIGENT_PHOTO_CAPTURE_CLICK_NEXT_QUESTION: {
            return Object.assign(Object.assign({}, state), { shouldMoveToNextQuestion: action.payload.shouldMoveToNextQuestion });
        }
        case INTELLIGENT_PHOTO_CAPTURE_CAMERA_MODEL_SUCCESS: {
            return Object.assign(Object.assign({}, state), { cameraModel: action.payload.cameraModel });
        }
        case INTELLIGENT_PHOTO_CAPTURE_RESET_CAPTURED_PHOTO: {
            return Object.assign(Object.assign({}, state), { capturedPhoto: undefined, files: undefined });
        }
        case INTELLIGENT_PHOTO_CAPTURE_PHOTO_UPLOAD_SUCCESS: {
            return Object.assign(Object.assign({}, state), { files: action.payload.files });
        }
        case INTELLIGENT_PHOTO_CAPTURE_PHOTO_UPLOAD_FAILURE: {
            return Object.assign(Object.assign({}, state), { files: undefined });
        }
        case INTELLIGENT_PHOTO_CAPTURE_PROGRESSIVE_IMAGE_MISC_ACTION: {
            return Object.assign(Object.assign({}, state), { prgMiscImage: action.payload });
        }
        default:
            return state;
    }
};
//# sourceMappingURL=photoCaptureIntelligentViewChangeReducer.js.map